import type { ReactNode } from "react";
import PageLayout from "./layout";

export default function (): ReactNode {
  return (
    <PageLayout title="Manage Platform">
      <section>
        <h2>Manage Platform</h2>
        <p>Please select a component of the platform to manage</p>
      </section>
    </PageLayout>
  );
}
